import { defineStore } from "pinia";

export const useNewHomeSearch = defineStore("newHomeSearch", () => {
  const filterReset = ref(false);

  return {
    filterReset,
  };
});
